exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel-heading h4[data-v-77bc69a8]{text-transform:uppercase;font-weight:500}[dir=ltr] .panel-heading h4[data-v-77bc69a8]{margin-left:-20px;padding-left:10px}[dir=rtl] .panel-heading h4[data-v-77bc69a8]{margin-right:-20px;padding-right:10px}.panel-flat[data-v-77bc69a8]{overflow-x:hidden!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-77bc69a8","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/exportOrder/addEditExportOrder.vue
// module id = 1393
// module chunks = 0